import { createSelector } from 'reselect';
import { RootState } from '../configureStore';

const selectNewsReducer = (state: RootState) => state.news;

const selectNews = createSelector(selectNewsReducer, (data) => data.news);
const selectNewsStatus = createSelector(selectNewsReducer, (data) => data.newsStatus);

export { selectNews, selectNewsStatus };
